import React from "react";
type ProspType = {
  code?: string;
  status?: string;
};
const ActivationRow = ({ code, status }: ProspType) => {
  return (
    <div className="tw-flex tw-justify-center md:tw-gap-12 tw-items-center tw-w-full lg:tw-w-[40%] lg:tw-gap-12 tw-gap-6">
      <p className="tw-w-1/2 tw-py-1 md:tw-py-2 tw-px-6 md:tw-px-20 tw-flex tw-items-center tw-justify-center tw-bg-palePink tw-text-[1rem] lg:text-[1.97rem] md:tw-text-[1.325rem] tw-font-bold ">
        {code}
      </p>
      {status === "active" ? (
        <button className=" tw-flex tw-items-center tw-py-1 md:tw-py-3 tw-px-6 md:tw-px-12 tw-font-bold tw-text-white tw-text-[0.75rem] md:tw-text-[1.125rem] tw-rounded-[0.375rem] md:tw-rounded-[0.625rem] tw-bg-reddishOrange">
          Activated
        </button>
      ) : (
        <button className="  tw-flex tw-text-center tw-py-1 md:tw-py-3 tw-px-6 md:tw-px-12 tw-font-bold tw-text-[0.75rem] md:tw-text-[1.125rem] tw-rounded-[0.375rem] md:tw-rounded-[0.625rem] tw-border-[1px] md:tw-border-2 tw-border-black ">
          Not&nbsp;Ready
        </button>
      )}
    </div>
  );
};
export default ActivationRow;
